import { render } from "./beneficiary_distributions.html?vue&type=template&id=cb8e8732&external"
import script from "./beneficiary_distributions.js?vue&type=script&lang=js&external"
export * from "./beneficiary_distributions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__